import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from '../Shared/colors';
import { decryptData } from "../../src/services/crypto";

export const NotFound = () => {
  const navigate = useNavigate();
  let role = null;
  let storedStaffRole = localStorage.getItem("role");
  if (storedStaffRole) {
    try {
      role = decryptData(storedStaffRole);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }

  const handleGoHome = () => {
    if (role === "ts") {
      navigate("/telesale");
    } else {
      navigate("/");
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <MainContainer>
      <ContentWrapper>
        <IconContainer>
          <NotFoundIcon>🔍</NotFoundIcon>
        </IconContainer>

        <ErrorCode>404</ErrorCode>
        <Title>Page Not Found</Title>

        <Subtitle>
          The page you're looking for doesn't exist or has been moved.
        </Subtitle>

        <ActionButtons>
          <PrimaryButton onClick={handleGoHome}>
            Go to Dashboard
          </PrimaryButton>
          <SecondaryButton onClick={handleGoBack}>
            Go Back
          </SecondaryButton>
        </ActionButtons>
      </ContentWrapper>
    </MainContainer>
  );
};

// Styled Components
const MainContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ContentWrapper = styled.div`
  background: ${colors.white};
  border-radius: 20px;
  padding: 3rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 500px;
  width: 90%;
`;

const IconContainer = styled.div`
  margin-bottom: 1.5rem;
`;

const NotFoundIcon = styled.div`
  font-size: 3rem;
  margin: 0 auto;
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(36, 147, 147, 0.3);
`;

const ErrorCode = styled.div`
  font-size: 4rem;
  font-weight: 900;
  color: ${colors.brown};
  margin: 0 0 1rem 0;
  line-height: 1;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: ${colors.text};
  margin: 0 0 1rem 0;
`;

const Subtitle = styled.h2`
  font-size: 1.1rem;
  font-weight: 500;
  color: ${colors.textMed};
  margin: 0 0 2rem 0;
  line-height: 1.4;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const PrimaryButton = styled.button`
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
  color: ${colors.white};
  border: none;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(36, 147, 147, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(36, 147, 147, 0.4);
  }
`;

const SecondaryButton = styled.button`
  padding: 0.75rem 1.5rem;
  background: ${colors.white};
  color: ${colors.brown};
  border: 2px solid ${colors.brown};
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: ${colors.brown};
    color: ${colors.white};
    transform: translateY(-2px);
  }
`;
